<template>
  <div>
    <div class="mb-4" v-if="!$store.getters.can('visiteur_bénévole')">
      <Link class="group flex items-center py-3" href="/applicants">
        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('contacts') ? 'fill-white' : 'fill-gray-400 group-hover:fill-white'" />
        <div :class="isUrl('applicants') ? 'text-white' : 'text-gray-400 group-hover:text-white'">{{$t('applicants.applicants')}}</div>
      </Link>
    </div>
    <div class="mb-4" v-if="!$store.getters.can('secretariat') && !$store.getters.can('visiteur_bénévole')">
      <Link class="group flex items-center py-3" :href='"/treatments?filter%5Bemployees%5D="+auth.user.id+"&filter%5Bstatus%5D=1"'>
        <icon name="pen-ruler" class="mr-2 w-4 h-4" :class="isUrl('treatments') ? 'fill-white' : 'fill-gray-400 group-hover:fill-white'" />
        <div :class="isUrl('treatments') ? 'text-white' : 'text-gray-400 group-hover:text-white'">{{$t('treatments.treatments')}}</div>
      </Link>
    </div>
    <div class="mb-4" v-if="$store.getters.can('visiteur_bénévole')">
      <Link class="group flex items-center py-3" :href='"/volunteer/treatments?filter%5Bstatus%5D=1"'>
        <icon name="pen-ruler" class="mr-2 w-4 h-4" :class="isUrl('volunteer/treatments') ? 'fill-white' : 'fill-gray-400 group-hover:fill-white'" />
        <div :class="isUrl('volunteer/treatments') ? 'text-white' : 'text-gray-400 group-hover:text-white'">{{$t('treatments.treatments')}}</div>
      </Link>
    </div>
    <div class="mb-4" v-if="$store.getters.can('admin') || $store.getters.can('bénévole') || $store.getters.can('secretariat')">
      <Link class="group flex items-center py-3" href="/volunteers">
        <icon name="hands" class="mr-2 w-4 h-4" :class="isUrl('volunteers') ? 'fill-white' : 'fill-gray-400 group-hover:fill-white'" />
        <div :class="isUrl('volunteers') ? 'text-white' : 'text-gray-400 group-hover:text-white'">{{$t('volunteers.volunteers')}}</div>
      </Link>
    </div>
    <div class="mb-4" v-if="$store.getters.can('visiteur_bénévole')">
      <Link class="group flex items-center py-3" href="/volunteer">
        <icon name="hands" class="mr-2 w-4 h-4" :class="isUrl('volunteer') ? 'fill-white' : 'fill-gray-400 group-hover:fill-white'" />
        <div :class="isUrl('volunteer') ? 'text-white' : 'text-gray-400 group-hover:text-white'">{{$t('volunteers.volunteer')}}</div>
      </Link>
    </div>
    <div class="mb-4" v-if="$store.getters.can('admin')">
      <Link class="group flex items-center py-3" href="/reports">
        <icon name="printer" class="mr-2 w-4 h-4" :class="isUrl('reports') ? 'fill-white' : 'fill-gray-400 group-hover:fill-white'" />
        <div :class="isUrl('reports') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Reports</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(url) {
      let currentUrl = this.$page.url.split('?')[0]
      if(currentUrl == '/'+url){
        return true
      }
      return false
    },
  },
  props: {
    auth: Object,
  },
}
</script>
